import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  divid: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  titleAct: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  backDrop: {
    marginTop: theme.spacing(5),
  },
  loading: {
    textAlign: 'center',
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(5),
  },
  sheba: {
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(1),
    '& *': {
      fontFamily: "'Vazir'",
    },
  },
  dangerBox: {
    marginTop: theme.spacing(0),
    backgroundColor: '#E7F5FD',
    borderRadius: '8px',
    border: 'solid 1px #BAE1F7',
    boxShadow: 'none',
    padding: theme.spacing(1.5),
    margin: '5px 0 0',
    display: 'flex',
    alignItems: 'center',
    '@media(max-width: 550px)': {
      flexDirection: 'column',
    },
    '& h3': {
      fontSize: '15px',

    }
  },
  dangerText: {
    fontSize: '12px',
    lineHeight: '25px',
    paddingLeft: '10px',
    textAlign: 'justify',
    COLOR: '#0C0E10',
    '@media(max-width: 550px)': {
      paddingLeft: '0',
    },
  },
  dangerLink: {
    color: '#ff5500',
  },
}));